import { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import './About.css';
import Footer from '../components/Footer';
import Navbar from '../components/Navbar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar, faHeart, faUsers, faBriefcase, faPlaceOfWorship, faGlobe } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
// import {
//   faHotel,
//   faTags,
//   faMapMarkedAlt,
//   faUmbrellaBeach,
//   faGlobeAsia,
//   faPassport,
//   faMoneyBillWave,
//   faHiking,
//   faSuitcaseRolling,
// } from '@fortawesome/free-solid-svg-icons';
import ServicesSection from "../components/ServicesSection";



function About() {
  const [isMobile, setIsMobile] = useState(false);
  // const [activeCard, setActiveCard] = useState(null);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const reelUrls = [
    "https://www.instagram.com/reel/DJO7_Blya4-/",
    "https://www.instagram.com/p/DHTVfxySu_W/",
    "https://www.instagram.com/reel/DDKKEa0SwSf/",
    "https://www.instagram.com/p/DIWSsxzy4yR/",
    "https://www.instagram.com/reel/DI6VjvyyP_h/",
    "https://www.instagram.com/reel/DIyjx5Mz-aM/",
    "https://www.instagram.com/p/DJMXIGkyLaV/",
    "https://www.instagram.com/reel/CfmP5xdjg_t/",
    "https://www.instagram.com/reel/CXbg1SFqlbD/",
    "https://www.instagram.com/reel/DD9g8uuSV_o/"
  ];

  return (
    <>
          <Navbar />
      {/* Breadcrumb Banner */}
      <div className='gap'></div>
      <section className="about-banner">
        <div className="banner-content">
          <h2>About Sonal Holidays</h2>
          <p className="breadcrumb">Home → About Us</p>
        </div>
        <p className="banner-label">About Us</p>
      </section>

      {/* Main About Section */}
      <section className="about-section">
        <div className="about-images">
          <div
            className="img-1"
            style={{
              backgroundImage: `url('/About_us/northern.jpg')`,
              backgroundSize: 'cover',         // shows entire image
              backgroundPosition: 'right',      // centers the image
            }}
          ></div>
          <div
            className="img-2"
            style={{
              backgroundImage: `url('/About_us/Beach.jpg')`,
              backgroundSize: 'cover',         // shows entire image
              backgroundPosition: 'right',      // centers the image
            }}
          ></div>
            <div
            className="img-3"
            style={{
              backgroundImage: `url('/About_us/traveller.jpg')`,
              backgroundSize: 'cover',         // shows entire image
              backgroundPosition: 'center',      // centers the image
            }}
          ></div>
        </div>

        <div className="about-content">
  <h5 className="about-tagline">Welcome To Sonal Holidays</h5>
  <h2 className="about-heading">We Curate Unforgettable Journeys Across the Globe</h2>

  <p className="about-desc">
    At Sonal Holidays, we don't just book trips—we curate unforgettable journeys across the globe! Whether you're looking to relax, explore, celebrate, or just take a break — from dreamy off-beat international adventures to deeply spiritual pilgrimage tours, we’ve got every traveler covered.
  </p>

  <p className="about-desc">
    We do it all!
  </p>

  <div className="about-features">
    <div className="feature">
      <div className="icon-circle"><FontAwesomeIcon icon={faStar} /></div>
      <div>
        <h5>Luxury Trips</h5>
        <p>Indulge in cinematic travel experiences—planned to perfection.</p>
      </div>
    </div>
    <div className="feature">
      <div className="icon-circle"><FontAwesomeIcon icon={faUsers} /></div>
      <div>
        <h5>Group Tours</h5>
        <p>Fun-filled, budget-friendly, and hassle-free holidays with others.</p>
      </div>
    </div>
    <div className="feature">
      <div className="icon-circle"><FontAwesomeIcon icon={faHeart} /></div>
      <div>
        <h5>Romantic & Family Trips</h5>
        <p>From honeymoons to family getaways, we’ve got you covered.</p>
      </div>
    </div>
    <div className="feature">
      <div className="icon-circle"><FontAwesomeIcon icon={faBriefcase} /></div>
      <div>
        <h5>Corporate Travel</h5>
        <p>Team outings, retreats, and client tours planned with precision.</p>
      </div>
    </div>
    <div className="feature">
      <div className="icon-circle"><FontAwesomeIcon icon={faPlaceOfWorship} /></div>
      <div>
        <h5>Pilgrimage Tours</h5>
        <p>Spiritual journeys to Kedarnath, Varanasi, Dwarka, Rameshwaram, Ajmer Sharif & more.</p>
      </div>
    </div>
    <div className="feature">
      <div className="icon-circle"><FontAwesomeIcon icon={faGlobe} /></div>
      <div>
        <h5>Offbeat Adventures</h5>
        <p>From Georgia to Kenya—safaris, Northern Lights, wine tasting & more.</p>
      </div>
    </div>
  </div>
  <br></br>
  <p className="about-desc">
    With offices in Navi Mumbai, Mumbai, Surat, and Bangalore — we’re always nearby to turn your travel dreams into a perfect itinerary.
  </p>

  <Link to="/contact" className="learn-more-btn">Contact Us →</Link>
</div>
      </section>


  <section className="services-section">
    <h5 className="services-subtitle">What We Offer</h5>
    <h2 className="services-title">Our Specialisation & Services</h2>
    <ServicesSection />
  </section>
            
  {/* <div className="services-feature-grid">
    <div className="service-feature">
      <div className="icon-circle"><FontAwesomeIcon icon={faSuitcaseRolling} /></div>
      <div>
        <h5>Airline Ticketing</h5>
        <p>Seamless flight bookings—domestic & international.</p>
      </div>
    </div>
    <div className="service-feature">
      <div className="icon-circle"><FontAwesomeIcon icon={faHotel} /></div>
      <div>
        <h5>Hotel Tie-Ups</h5>
        <p>Access to our network of trusted stays.</p>
      </div>
    </div>
    <div className="service-feature">
      <div className="icon-circle"><FontAwesomeIcon icon={faTags} /></div>
      <div>
        <h5>Budget-Friendly</h5>
        <p>Custom trips without breaking the bank.</p>
      </div>
    </div>
    <div className="service-feature">
      <div className="icon-circle"><FontAwesomeIcon icon={faMapMarkedAlt} /></div>
      <div>
        <h5>Personalized Planning</h5>
        <p>Travel designed for your pace, budget, and dreams.</p>
      </div>
    </div>
    <div className="service-feature">
      <div className="icon-circle"><FontAwesomeIcon icon={faUmbrellaBeach} /></div>
      <div>
        <h5>Staycations & Workations</h5>
        <p>Short breaks to refresh or work remotely.</p>
      </div>
    </div>
    <div className="service-feature">
      <div className="icon-circle"><FontAwesomeIcon icon={faGlobeAsia} /></div>
      <div>
        <h5>Inbound & Outbound Tours</h5>
        <p>Domestic gems and global getaways.</p>
      </div>
    </div>
    <div className="service-feature">
      <div className="icon-circle"><FontAwesomeIcon icon={faPassport} /></div>
      <div>
        <h5>Visa Assistance</h5>
        <p>Quick & smooth documentation support.</p>
      </div>
    </div>
    <div className="service-feature">
      <div className="icon-circle"><FontAwesomeIcon icon={faMoneyBillWave} /></div>
      <div>
        <h5>Forex</h5>
        <p>Currency exchange made simple & safe.</p>
      </div>
    </div>
    <div className="service-feature">
      <div className="icon-circle"><FontAwesomeIcon icon={faHiking} /></div>
      <div>
        <h5>Adventure Tours</h5>
        <p>Thrilling experiences in scenic destinations.</p>
      </div>
    </div>
    <div className="service-feature">
      <div className="icon-circle"><FontAwesomeIcon icon={faHeart} /></div>
      <div>
        <h5>Family & Honeymoon Tours</h5>
        <p>Romantic and bonding getaways, planned with care.</p>
      </div>
    </div>
  </div> */}
{/* </section> */}


      <section className="instagram-section">
        {!isMobile ? (
          <div
            className="insta-scroll"
            onMouseEnter={() =>
              document.querySelector('.insta-scroll').style.animationPlayState = 'paused'
            }
            onMouseLeave={() =>
              document.querySelector('.insta-scroll').style.animationPlayState = 'running'
            }
          >
            {reelUrls.concat(reelUrls.slice(0, 3)).map((url, index) => (
              <div className="insta-post" key={index}>
                <iframe
                  src={`${url}embed`}
                  title={`Instagram Reel ${index}`} // ✅ Add unique title
                  className="insta-embed"
                  frameBorder="0"
                  allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                  allowFullScreen
                ></iframe>
              </div>
            ))}
          </div>
        ) : (
          <Swiper
            slidesPerView={1.2}
            spaceBetween={16}
            loop={true}
            autoplay={{ delay: 3000, disableOnInteraction: false }}
          >
            {reelUrls.map((url, index) => (
              <SwiperSlide key={index}>
                <div className="insta-post">
                  <iframe
                    src={`${url}embed`}
                    title={`Instagram Reel Mobile ${index}`} // ✅ Add unique title
                    className="insta-embed"
                    frameBorder="0"
                    allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </div>
              </SwiperSlide>
            ))}

          </Swiper>
        )}
      </section>


      <Footer />
    </>
  );
}

export default About;
